import { Component, createRef } from 'react'
import PropTypes from 'prop-types'
import { noop } from 'lodash'

export default class Input extends Component {
  static propTypes = {
    id: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.string,
    spellCheck: PropTypes.bool,
    type: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    className: PropTypes.string,
    placeholder: PropTypes.string,
    autoFocus: PropTypes.bool,
    autoComplete: PropTypes.string,
    readOnly: PropTypes.bool,
    indeterminate: PropTypes.bool,
    disabled: PropTypes.bool,
    onBlur: PropTypes.func,
    step: PropTypes.string,
    checked: PropTypes.bool,
    inputMode: PropTypes.string,
  }
  static defaultProps = {
    id: null,
    name: null,
    value: null,
    spellCheck: null,
    type: 'text',
    step: null,
    className: 'input',
    checked: null,
    onChange: noop,
    onBlur: noop,
    autoFocus: false,
    autoComplete: null,
    placeholder: null,
    readOnly: false,
    indeterminate: false,
    disabled: false,
    inputMode: null,
  }

  constructor(props) {
    super(props)
    this.$inputRef = createRef()
  }

  handleChange = event => {
    const { name } = this.props
    const { value, checked } = event.target
    const data = { name, value, checked }
    this.props.onChange(data)
  }

  componentDidMount() {
    const { indeterminate } = this.props
    this.$inputRef.current.indeterminate = indeterminate
  }

  componentDidUpdate(prevProps, prevState) {
    const { indeterminate } = this.props
    this.$inputRef.current.indeterminate = indeterminate
  }

  // Note: iOS doesn't trigger the blur event when pressing done on iOS keyboard. See https://github.com/facebook/react/issues/28492
  render() {
    const {
      id,
      name,
      value,
      className,
      type,
      spellCheck,
      step,
      checked,
      placeholder,
      autoFocus,
      autoComplete,
      readOnly,
      disabled,
      onBlur,
      onKeyDown,
      inputMode,
    } = this.props
    return (
      <input
        className={className}
        id={id}
        name={name}
        value={value}
        type={type}
        spellCheck={spellCheck}
        step={step}
        checked={checked}
        onChange={this.handleChange}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
        placeholder={placeholder}
        autoFocus={autoFocus}
        autoComplete={autoComplete}
        readOnly={readOnly}
        disabled={disabled}
        ref={this.$inputRef}
        inputMode={inputMode}
      />
    )
  }
}
